import React, { useState } from "react"
import pageMessageBroker from './page_message_broker';

export default function FieldValueEdit({value, update_attribute_url_path, path}) {
  const [renderMode, setRenderMode] = useState('menu')
  const [newValue, setNewValue] = useState(value)
  const [note, setNote] = useState('')
  const [editState, setEditState] = useState('editing')

  const handleSave = (e) => {
    e.preventDefault();
    setEditState('processing')

    const data = {
      path: path,
      value: newValue,
      note: note,
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    fetch(update_attribute_url_path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      credentials: 'include',
      body: JSON.stringify(data),
    })
    .then(response => {
      if (response.ok) {
        pageMessageBroker.dispatch("fieldValueSaved", {})
      } else {
        console.error('Failed to update attribute');
        setEditState('editing')
        alert('Failed to update attribute');
      }
    })
    .catch(error => {
      console.error('Error updating attribute:', error);
      setEditState('editing')
      alert('Error updating attribute');
    })
  }

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="w-full flex gap-4 items-center justify-end">
        <button onClick={() => setRenderMode('editing')} disabled={renderMode !== 'menu'} className={"button button__primary" + (renderMode === 'menu' ? '' : ' button__disabled')}>Edit</button>
        {null/*<button onClick={() => setRenderMode('adding note')} disabled={renderMode !== 'menu'} className={"button" + (renderMode === 'menu' ? '' : ' button__disabled')}>Add note</button>*/}
      </div>

      {renderMode === 'editing' && (
        <div className="w-full flex flex-col gap-4">
          <form className="w-full flex flex-col gap-4" onSubmit={handleSave}>
            <div className="flex flex-col gap-2">
              <label htmlFor="field_value" className="text-gray-700 text-sm font-bold">New value</label>
              <input type="text" id="field_value" value={newValue} onChange={(e) => setNewValue(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="field_note" className="text-gray-700 text-sm font-bold">Change note (optional)</label>
              <textarea id="field_note" value={note} onChange={(e) => setNote(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
            </div>

            <div className="flex gap-4 items-center justify-end">
              <button type="submit" disabled={editState !== 'editing'} className={"button button__primary" + (editState === 'editing' ? '' : ' button__disabled')}>Save</button>
              <button type="cancel" onClick={() => setRenderMode('menu')} disabled={editState !== 'editing'} className={"button" + (editState === 'editing' ? '' : ' button__disabled')}>Cancel</button>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}
